import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["errorText", "errorId", "collapseError"];
import React from 'react';
import styled, { css } from 'styled-components';
import { flex, TRANSITION_DEFAULT } from '../../../../styling';
import { Div } from '../../../Styled';
import { HelperText } from '../../../text';
var ErrorContainer = /*#__PURE__*/styled(Div).withConfig({
  displayName: "InputError__ErrorContainer",
  componentId: "sc-pu8zlu-0"
})(["padding-top:8px;min-height:32px;", ";opacity:", ";pointer-events:none;", ""], flex('flex-start', 'flex-start'), function (_ref) {
  var $active = _ref.$active;
  return $active ? 1 : 0;
}, function (_ref2) {
  var $collapseError = _ref2.$collapseError,
      $active = _ref2.$active;
  return $collapseError ? css(["position:", ";"], $active ? 'unset' : 'absolute') : css(["transition:opacity ", ";"], TRANSITION_DEFAULT);
});

var InputError = function InputError(_ref3) {
  var errorText = _ref3.errorText,
      errorId = _ref3.errorId,
      _ref3$collapseError = _ref3.collapseError,
      collapseError = _ref3$collapseError === void 0 ? false : _ref3$collapseError,
      rest = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(ErrorContainer, _extends({
    $active: !!errorText,
    $collapseError: collapseError
  }, rest), /*#__PURE__*/React.createElement(HelperText, {
    error: true,
    "aria-live": "polite",
    id: errorId ? "".concat(errorId, "-error-text") : undefined,
    "data-test-id": errorId ? "".concat(errorId, "-error-text") : undefined
  }, errorText));
};

export default InputError;